export interface CaptionPart {
  text: string;
  isHashtag: boolean;
}

const HASHTAG = /(#[\p{L}\p{N}_]+)/gu;

/**
 * Splits a caption so a preview can tint its hashtags.
 *
 * Plain text in, plain parts out — no markup is produced here, so a caption can
 * never inject anything into the preview.
 */
export function hashtagParts(caption: string): CaptionPart[] {
  return caption
    .split(HASHTAG)
    .filter((piece) => piece !== '')
    .map((piece) => ({ text: piece, isHashtag: piece.startsWith('#') }));
}
